Vue.component('kk-clear-refinements-button', {
  template: "#kk-clear-refinements-button",
  props: {
    canRefine: {
      type: Boolean,
      required: true
    },
    refine: {
      type: Function,
      required: true
    },
    createUrl: {
      type: Function
    },
    inPanel: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {};
  },
});
